export default __webpack_public_path__ + "static/media/P.2b0be2a8.svg";